import React, { Component } from 'react';
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
// import { makeStyles } from '@material-ui/core/styles';

import NavBar from './components/NavBar';
import SearchPixabay from './components/SearchPixabay';
import Footer from './components/Footer';

class App extends Component {
	render() {
		return (
			<div className="App">
				<MuiThemeProvider>
					<NavBar />
					<div className="after-nav">
						<SearchPixabay />
					</div>
					<Footer />
				</MuiThemeProvider>
			</div>
		);
	}
}

export default App;